module.exports = __webpack_public_path__ + "static/media/chart1_data.88d46de4.csv";